import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

export const enterprisesAPI = {
  list: () => api.get('/enterprises'),
  get: (id) => api.get(`/enterprises/${id}`),
  create: (data) => api.post('/enterprises', data),
  update: (id, data) => api.put(`/enterprises/${id}`, data),
  delete: (id) => api.delete(`/enterprises/${id}`),
};

export const sitesAPI = {
  list: (enterpriseId) => api.get('/sites', { params: { enterprise_id: enterpriseId } }),
  get: (id) => api.get(`/sites/${id}`),
  create: (data) => api.post('/sites', data),
  update: (id, data) => api.put(`/sites/${id}`, data),
  delete: (id) => api.delete(`/sites/${id}`),
};

export const eligibilityRulesAPI = {
  list: (search) => api.get('/eligibility-rules', { params: { search } }),
  create: (data) => api.post('/eligibility-rules', data),
  update: (id, data) => api.put(`/eligibility-rules/${id}`, data),
  delete: (id) => api.delete(`/eligibility-rules/${id}`),
};

export const eligibilityRulesTicgnAPI = {
  list: (search) => api.get('/eligibility-rules-ticgn', { params: { search } }),
  create: (data) => api.post('/eligibility-rules-ticgn', data),
  update: (id, data) => api.put(`/eligibility-rules-ticgn/${id}`, data),
  delete: (id) => api.delete(`/eligibility-rules-ticgn/${id}`),
};

export const analysesAPI = {
  list: (params) => api.get('/analyses', { params }),
  get: (id) => api.get(`/analyses/${id}`),
  create: (data) => api.post('/analyses', data),
  update: (id, data) => api.put(`/analyses/${id}`, data),
  delete: (id) => api.delete(`/analyses/${id}`),
  downloadPDF: (id) => api.get(`/analyses/${id}/pdf`, { responseType: 'blob' }),
};

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
};

export const adminAPI = {
  populateNAF: () => api.post('/admin/populate-naf'),
  
  // Barèmes TICFE
  getBaremesTICFE: () => api.get('/admin/baremes-ticfe'),
  updateBaremesTICFE: (categorie, baremes) => api.put('/admin/baremes-ticfe', { categorie, baremes }),
  updateAllBaremesTICFE: (baremes) => api.put('/admin/baremes-ticfe/all', { baremes }),
  
  // Coefficients TURPE
  getCoefficientsTURPE: () => api.get('/admin/coefficients-turpe'),
  updateCoefficientsTURPE: (coefficients) => api.put('/admin/coefficients-turpe', { coefficients }),
  
  // Composantes TURPE
  getComposantesTURPE: () => api.get('/admin/composantes-turpe'),
  updateComposantesTURPE: (composantes) => api.put('/admin/composantes-turpe', { composantes }),
};